import React from 'react';
import img from '../img/logout.png.js';

const Image = () => /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("img", { src: img, alt: "logout" }));
Image.displayName = "Forms.LogoutForm.Image";

export { Image };
//# sourceMappingURL=index.js.map
